import React, { ReactNode } from 'react';
import { FiPackage, FiStar } from 'react-icons/fi';
import Rating from '@material-ui/lab/Rating';
import { MdDone } from 'react-icons/md';
import { FaHourglassStart } from 'react-icons/fa';
import { emojiBasedOnAvgRating } from '../shift/AddMultipleCourierModal/CourierBox';

import './CouriersScoreTimeline.scss';

function ContainerBox({
  title,
  paragraph,
  Icon,
  side,
  time,
}: {
  title: string;
  paragraph: string;
  Icon: ReactNode;
  side: string;
  time: string;
}): JSX.Element {
  return (
    <div className={`container ${side}`}>
      {Icon}
      {time.length > 0 && <div className="date">{time}</div>}
      <div className="content">
        <h2>{title}</h2>
        <p>{paragraph}</p>
      </div>
    </div>
  );
}

function ContainerBoxWithCard({
  title,
  Card,
  Icon,
  side,
  time,
}: {
  title: string;
  Card: ReactNode;
  Icon: ReactNode;
  side: string;
  time: string;
}): JSX.Element {
  return (
    <div className={`container ${side}`}>
      {Icon}
      {time.length > 0 && <div className="date">{time}</div>}
      <div className="content">
        <h2>{title}</h2>
        <> {Card} </>
      </div>
    </div>
  );
}

export function CouriersScoreTimeline({
  startTime,
  endTime,
  totalDeliveries,
  averageRating,
  ordersPerHour,
  counterText,
}: {
  startTime: string;
  endTime: string;
  totalDeliveries: number;
  averageRating: number;
  ordersPerHour: number;
  counterText: string;
}): JSX.Element {
  return (
    <div className="timeLinePage">
      <div className="timeline">
        <ContainerBox
          title={'First delivery'}
          paragraph={''}
          Icon={<FaHourglassStart className="icon" />}
          side={'left'}
          time={startTime}
        />
        <ContainerBoxWithCard
          title={'Stats 🔍'}
          Card={
            <div>
              <div>{`${totalDeliveries} Deliveries `}</div>
              <div>{`${ordersPerHour} 📦 per hour!`}</div>
            </div>
          }
          Icon={<FiPackage className="icon" />}
          side={'right'}
          time={''}
        />
        <ContainerBoxWithCard
          title={`${
            averageRating === 0 ? '' : emojiBasedOnAvgRating(averageRating)
          } Avg Rating (${averageRating})`}
          Card={
            <div>
              <div>
                {' '}
                <Rating
                  name="half-rating-read"
                  size="large"
                  defaultValue={averageRating}
                  precision={0.5}
                  readOnly
                />
              </div>
            </div>
          }
          Icon={<FiStar className="icon" />}
          side={'left'}
          time={''}
        />
        <ContainerBoxWithCard
          title={'Last delivery'}
          Card={
            <div>
              <div>
                {`Total time:  ${counterText !== null ? counterText : ''}`}
              </div>
            </div>
          }
          Icon={<MdDone className="icon" />}
          side={'right'}
          time={endTime}
        />
      </div>
    </div>
  );
}
